<script setup>
import { computed } from 'vue'

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])

const dataValue = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  },
})
</script>

<template>
  <div class="product__quantity">
    <a href="#" class="product__quantity-btn" @click.prevent="dataValue = Math.max(1, Number(dataValue) - 1)">-</a>
    <input
        type="number"
        min="1"
        v-model="dataValue"
        class="product__quantity-input"
        @focus="$event.target.select()"
    />
    <a href="#" class="product__quantity-btn" @click.prevent="dataValue = Number(dataValue) + 1">+</a>
  </div>
</template>

<style lang="scss" scoped>
.product__quantity {
  display: flex;
  align-items: center;
  border-radius: 24px;
  background: var(--neutral-50, #F5F5F5);

  .product__quantity-btn, .product__quantity-input {
    text-align: center;
    font-family: Outfit, 'Outfit Fallback', Arial, serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px; /* 150% */
  }

  .product__quantity-btn {
    text-decoration: none;
    padding: 13px 15px;
    color: var(--neutral-700, #767370);
  }
  .product__quantity-input {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    outline: none;
    border: 0;
    background: var(--neutral-50, #F5F5F5);
    padding: 13px 0;
    max-width: 30px;
    color: var(--neutral-1000, #3C3833);
  }

  .product__quantity-input::-webkit-outer-spin-button,
  .product__quantity-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
